import { useMemo } from "react";
import { useProformas } from "@/hooks/queries/useProformas";
import {
  filterProformas,
  getProformaMetrics,
  sortProformasByNewest,
} from "../proforma-calculations";
import type { ProformaStatusFilter } from "../proforma.constants";

export function useProformasPageData(filters: {
  search: string;
  statusFilter: ProformaStatusFilter;
}) {
  const { data: proformas = [], isLoading } = useProformas();

  const sortedProformas = useMemo(() => sortProformasByNewest(proformas), [proformas]);
  const filteredProformas = useMemo(
    () => filterProformas(sortedProformas, filters.search, filters.statusFilter),
    [filters.search, filters.statusFilter, sortedProformas],
  );
  const metrics = useMemo(() => getProformaMetrics(proformas), [proformas]);

  return {
    proformas,
    sortedProformas,
    filteredProformas,
    latest: sortedProformas[0],
    metrics,
    isLoading,
  };
}
